import { TableCell, TableRow } from "@mui/material";
import EmptyContent from "../empty-content";
import { Theme, SxProps } from "@mui/material/styles";

const TableNoDataComponent = ({ sx } : { sx?: SxProps<Theme> }) => {

    return (
        <TableRow>
            <TableCell colSpan={12}>
                <EmptyContent
                    filled
                    title="Nada Encontrado"
                    sx={{
                        py: 10,
                        ...sx
                    }}
                />
            </TableCell>
        </TableRow>
    );

}

export default TableNoDataComponent;